import { render, staticRenderFns } from "./BreakTextPage.vue?vue&type=template&id=5c916b3b&"
import script from "./BreakTextPage.vue?vue&type=script&lang=js&"
export * from "./BreakTextPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports